import { Component, OnInit, OnDestroy, HostListener, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Subject } from 'rxjs';
import { PermissionService } from '../../../services/permission.service';
import { UserPermission } from '../../../models/permission.model';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {
  isOpen = false;
  isPinned = false;
  private destroy$ = new Subject<void>();

  // Expose UserPermission enum to template
  UserPermission = UserPermission;

  constructor(
    private renderer: Renderer2,
    public permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    // Load pinned state from localStorage
    const pinned = localStorage.getItem('sidebarPinned');
    this.isPinned = pinned === 'true';
    this.isOpen = this.isPinned;

    // Apply body class if pinned
    if (this.isPinned) {
      this.renderer.addClass(document.body, 'sidebar-pinned');
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleSidebar(): void {
    this.isOpen = !this.isOpen;
  }

  togglePin(): void {
    this.isPinned = !this.isPinned;
    localStorage.setItem('sidebarPinned', this.isPinned.toString());

    if (this.isPinned) {
      this.isOpen = true;
      this.renderer.addClass(document.body, 'sidebar-pinned');
    } else {
      this.renderer.removeClass(document.body, 'sidebar-pinned');
    }
  }

  closeSidebar(): void {
    if (!this.isPinned) {
      this.isOpen = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    // Close sidebar when clicking outside if not pinned
    if (!this.isPinned && this.isOpen && !target.closest('.sidebar') && !target.closest('.sidebar-toggle')) {
      this.isOpen = false;
    }
  }
}


